/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/DesignSystem/Choice",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderColor = "#f2f2f2",
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  onClick,
  width = "100%",
  isSelected,
  backgroundColorSelected = "rgba(0,188,112,0.7)",
  borderColorSelected = "rgba(19,126,197,0)",
  backgroundColorHovered = "rgba(19,126,197,0.1)",
  borderColorHovered = "rgba(19,126,197,0)",
  fontSize = 16,
  fontWeight = 400,
  textTransform = "none",
  text = "",
  colorSelected = "#fff",
  colorHovered = "rgba(0,188,112,1)"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="Choice.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-2nHSyF': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-2nHSyF': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-2nHSyF': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-2nHSyF': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--w-7-2nHSyF': typeof width === 'number' ? `${width}px` : width,'--bc-1-2nHSyF': isSelected ? backgroundColorSelected : isHovered ? backgroundColorHovered : "#ffffff",'--bc-4-2nHSyF': isSelected ? borderColorSelected : isHovered ? borderColorHovered : borderColor}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Choice.Text"
  data-view-path={viewPath}
 style={{'--fs-9-2nHSyF': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-10-2nHSyF': fontWeight,'--tt-11-2nHSyF': textTransform,'--c-8-2nHSyF': isSelected ? colorSelected : isHovered ? colorHovered : "#303030"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}